import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import throttle from '@/utils/throttle';
import { mcApiUrl, mode } from '@/config';
// import useComponentStore from '@/stores/componentStore';

// const { openAlertModal } = useComponentStore();

// API Client
export const apiClient = axios.create({
  baseURL: mcApiUrl,
  withCredentials: true,
});

let tokenRefreshHost = mcApiUrl;

const errors = [
  {
    status: 401,
    statusText: 'Unauthorized',
    async func() {
      // clear sessionStorage
      sessionStorage.clear();

      // openAlertModal({
      //   title: 'Unauthorized',
      //   content: '인증정보가 올바르지 않습니다.',
      //   blockClose: true,
      // });
    },
  },
  {
    status: 400,
    statusText: 'Bad Request',
    async func() {
      // TODO: const { openAlertDialog } = useComponentStore();
      // await openAlertDialog({ content: 'messageUsageJourney.wrongRequests' });
    },
  },
  {
    status: 403,
    statusText: 'Forbidden',
    async func() {
      // clear sessionStorage
      sessionStorage.clear();

      // TODO: const { openAlertDialog } = useComponentStore();
      // await openAlertDialog({ content: 'messageUsageJourney.wrongRequests' });
    },
  },
  {
    status: 500,
    statusText: 'Internal Server Error',
    async func() {
      // openAlertModal({ title: 'Internal Server Error', content: '서버 에러' });
    },
  },
  {
    status: 404,
    statusText: 'Not Found',
    async func() {
      // openAlertModal({ title: 'Not Found', content: '페이지를 찾을수 없음' });
    },
  },
  {
    status: 'ERR_NETWORK',
    statusText: 'Network Error',
    async func() {
      // TODO: const { openAlertDialog } = useComponentStore();
      // await openAlertDialog({ content: 'common.globalError' });
    },
  },
];

const errorMap = { status: {}, statusText: {} };

errors.forEach(({ status, statusText, func }) => {
  const throttleFunc = throttle(func, 400);

  errorMap.status[status] = throttleFunc;
  errorMap.statusText[statusText] = throttleFunc;
});

export const setAuthorization = ({ authorization }) => {
  apiClient.defaults.headers.common.Authorization = authorization ? `Bearer ${authorization}` : '';
};

export const setBaseURL = ({ url }) => {
  tokenRefreshHost = url;
  apiClient.defaults.baseURL = url;
};

// init authorization
if (sessionStorage.getItem('accessToken')) {
  setAuthorization({ authorization: sessionStorage.getItem('accessToken') });
}

// token refresh
export const tokenRefresh = async () => {
  sessionStorage.clear();

  try {
    const response = await axios.post(`${tokenRefreshHost}/accounts/token`, null, {
      withCredentials: true,
    });

    if (response.data.accessToken) {
      sessionStorage.setItem('accessToken', response.data.accessToken);
      sessionStorage.setItem('idToken', response.data.idToken);
      setAuthorization({ authorization: response.data.accessToken });
    }

    if (!response.data.accessToken) {
      throw new Error('Sorry, your token expired');
    }

    return response.data.accessToken;
  } catch (error) {
    Promise.reject(new Error('Sorry, your token expired'));

    if (mode !== 'local') {
      // TODO
      // window.location.href = '/loading';
    }
    return error;
  }
};

// request interceptor
apiClient.interceptors.request.use(async (config) => {
  if (['/accounts/login', '/accounts/token'].includes(config.url)) {
    return config;
  }

  const temp = config;
  let [, headerToken] = (config.headers.Authorization || '').split(' ');

  if (!headerToken) {
    const accessToken = await tokenRefresh();
    temp.headers.Authorization = `Bearer ${accessToken}`;

    headerToken = accessToken;
  }

  const payload = jwtDecode(headerToken);
  const exp = payload?.exp ?? 0;

  if (exp < Date.now() / 1000) {
    const accessToken = await tokenRefresh();
    temp.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
}, (error) => Promise.reject(error));

// response interceptor
apiClient.interceptors.response.use(
  (response) => {
    if (response.headers['content-disposition']) {
      return response;
    }

    if (response.status === 201) {
      return response.headers.location;
    }

    return response.data;
  },
  (error) => {
    const status = error.response?.status ?? error.code;
    const statusText = error.response?.statusText;

    const temp = errorMap.status[status] ?? errorMap.statusText[statusText];

    if (typeof temp === 'function') {
      temp(error);
    }

    return Promise.reject(error);
  },
);
